import { useState } from 'react';
import { Button, Input } from '../../../../shared/ui';
import { UpdateUserData } from '../../../../shared/utils';
import './ContactDetailsSection.css';

interface ContactDetailsSectionProps {
  phone?: string;
  email: string;
  onSave: (data: Pick<UpdateUserData, 'phone'>) => Promise<void>;
  loading: boolean;
}

export const ContactDetailsSection = ({
  phone,
  email,
  onSave,
  loading,
}: ContactDetailsSectionProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [phoneValue, setPhoneValue] = useState(phone ?? '');

  const handleSave = async (e: React.FormEvent) => {
    e.preventDefault();
    await onSave({ phone: phoneValue.trim() || undefined });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setPhoneValue(phone ?? '');
    setIsEditing(false);
  };

  return (
    <div>
      <div className="contact-section__header">
        <h3 className="contact-section__title">Contact Details</h3>
        {!isEditing && (
          <Button
            variant="outlined"
            size="small"
            onClick={() => setIsEditing(true)}
            disabled={loading}
          >
            Edit
          </Button>
        )}
      </div>

      {isEditing ? (
        <form onSubmit={handleSave} className="contact-section__form">
          <Input
            label="Telephone / WhatsApp No."
            name="phone"
            type="tel"
            value={phoneValue}
            onChange={e => setPhoneValue(e.target.value)}
            placeholder="+49 123 456789"
            fullWidth
          />
          <Input
            label="Email Address"
            name="email"
            type="email"
            value={email}
            readOnly
            disabled
            fullWidth
            help="Email address is linked to your account and cannot be changed here."
          />
          <div className="contact-section__form-actions">
            <Button
              type="button"
              variant="outlined"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </Button>
          </div>
        </form>
      ) : (
        <div className="contact-section__info-grid">
          <div className="contact-section__info-item">
            <span className="contact-section__info-label">
              Telephone / WhatsApp No.
            </span>
            <span
              className={`contact-section__info-value ${!phone ? 'contact-section__info-value--empty' : ''}`}
            >
              {phone || 'Not set'}
            </span>
          </div>
          <div className="contact-section__info-item">
            <span className="contact-section__info-label">Email Address</span>
            <span className="contact-section__info-value contact-section__info-value--readonly">
              {email}
            </span>
            <span className="contact-section__readonly-note">
              Managed via account settings
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
